var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoltShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58594 23.6602C9.77344 23.6602 10.0664 23.5898 10.3594 23.4375C17.0273 19.9453 19.1719 18.1992 19.1719 13.9922V5.15625C19.1719 3.94922 18.6562 3.5625 17.6719 3.15234C16.3008 2.58984 11.918 0.996094 10.5586 0.527344C10.2422 0.421875 9.91406 0.363281 9.58594 0.363281C9.25781 0.363281 8.92969 0.433594 8.625 0.527344C7.25391 0.972656 2.87109 2.60156 1.5 3.15234C0.527344 3.55078 0 3.94922 0 5.15625V13.9922C0 18.1992 2.26172 19.7461 8.8125 23.4375C9.11719 23.6016 9.39844 23.6602 9.58594 23.6602ZM4.30078 12.3984C4.30078 12.2578 4.37109 12.082 4.5 11.9297L11.1211 3.62109C11.625 2.98828 12.4688 3.41016 12.1641 4.19531L9.98438 10.0547H14.0742C14.3906 10.0547 14.625 10.2773 14.625 10.5938C14.625 10.7344 14.5547 10.9102 14.4258 11.0625L7.80469 19.3711C7.30078 20.0039 6.46875 19.582 6.76172 18.8086L8.95312 12.9375H4.85156C4.54688 12.9375 4.30078 12.7148 4.30078 12.3984Z",
    fill: "#FF9500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltShield);
export default __webpack_public_path__ + "static/media/bolt-shield.8b2430d7b6d45d32521691647630e57b.svg";
export { ForwardRef as ReactComponent };